var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-1.208 7.32c0 .195.086.374.242.523l5.188 5.18c.156.148.32.218.508.218.382 0 .687-.281.687-.672 0-.187-.07-.375-.195-.492l-1.75-1.781L.839 7.898l1.89.117h9.883c.407 0 .688-.29.688-.696 0-.406-.281-.695-.688-.695H2.73l-1.883.117 2.625-2.398 1.75-1.781c.125-.125.195-.305.195-.493 0-.39-.305-.671-.687-.671-.188 0-.352.062-.524.234L-.966 6.796c-.156.148-.242.328-.242.523z",
    transform: "translate(-512 -734) translate(0 714) translate(13 9) translate(491 5) translate(8 6.667) rotate(90 6.046 7.32)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.6dc67561.svg";
export { ForwardRef as ReactComponent };